// React imports.
import React from "react";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";


const Assessment1QuestionsUnderReporting = ({fuelType, state, showDontKnowNote }) => (
    <div>
        <ol>
            <li>
                One or more of the vendors did not include usage charges (e.g. variable costs) in the expenditure amounts they reported to you. If that occurred, you would need to ask them to provide the cost of the kWh used for those households.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors reported the cost of the kWh used but did not include the monthly fixed charge. If that occurred, you would need to ask them to report information on the household’s entire bill, not just the usage charges.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors only reported data for the heating season. If that occurred, you would need to ask them to report data for the whole year.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors included some households who had less than 12 months of data. If that occurred, you would need to 	ask them to identify which households had a full year of data and which households only were served for part of the year.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors offers some type of rate discount to some of their LIHEAP recipient customers. If that occurred, it is important for you to know, but the data are still valid.
                <br/><br/>
            </li>
        </ol>

        Let's walk through each of these issues so that you can assess whether any of them might be a problem for your data.&nbsp;
        {showDontKnowNote === true
          &&<span>
                Please answer each of the questions below. Depending on your response, each
                question may ask you to outline an action item to help you address the issue.
                <br/><br/>
                <strong>
                    If you don't know the answer to a question please indicate "No/Don't Know"
                    and provide your plans to acquire this information from IT department or
                    programming staff in the response box.
                </strong>
            </span>}
        <br/><br/>
        <ol>
            {/*USAGE*/}
            <li>
                Do your {fuelType.description}&nbsp;vendors indicate they are including energy usage charges
                (e.g. variable costs) in the expenditure amounts they report to you?<br/>
                <label>
                    <input type="radio"
                        name="IncludingEnergyUseChargesFlag"
                        id="IncludingEnergyUseChargesFlag_true"
                        value="true"
                        checked={fuelType.IncludingEnergyUseChargesFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyUseChargesFlag"
                        id="IncludingEnergyUseChargesFlag_false"
                        value="false"
                        checked={fuelType.IncludingEnergyUseChargesFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludingEnergyUseChargesFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.IncludingEnergyUseChargesFlag === false
                  &&
                      <span>
                          <strong>Requires followup.</strong>&nbsp; 
                          The expenditure amounts reported by your {fuelType.description}&nbsp;vendors should include energy usage charges.
                          If your vendors are not including this information it will cause your average&nbsp;
                          {fuelType.description}&nbsp;expenditures to be underreported.
                          <br/><br/>
                          Please indicate your plans to address this issue in the box below
                          <textarea  name="IncludingEnergyUseChargesDesc"
                              id="IncludingEnergyUseChargesDesc" style={{width:"100%"}}
                              value={fuelType.IncludingEnergyUseChargesDesc}
                              onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                      </span>}
                <br/><br/>
            </li>

            {/*DELIVERY*/}
            <li>
                Do your {fuelType.description}&nbsp;vendors indicate they are including energy delivery, fixed charges, and taxes
                (e.g. transmission, regular monthly charges) in the expenditure amounts they report to you?
                <br/>
                <label>
                    <input type="radio"
                        name="IncludingEnergyDeliveryChargesFlag"
                        id="IncludingEnergyDeliveryChargesFlag_true"
                        value="true"
                        checked={fuelType.IncludingEnergyDeliveryChargesFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyDeliveryChargesFlag"
                        id="IncludingEnergyDeliveryChargesFlag_false"
                        value="false"
                        checked={fuelType.IncludingEnergyDeliveryChargesFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludingEnergyDeliveryChargesFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.IncludingEnergyDeliveryChargesFlag === false
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        The expenditure amounts reported by your {fuelType.description}&nbsp;vendors should include delivery, fixed charges,
                        and taxes. If your vendors are not including this information it will cause your average
                        &nbsp;{fuelType.description}&nbsp;expenditures to be underreported.
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IncludingEnergyDeliveryChargesDesc"
                        id="IncludingEnergyDeliveryChargesDesc" style={{width:"100%"}}
                        value={fuelType.IncludingEnergyDeliveryChargesDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*COMPLETE 12 MONTH*/}
            <li>
                Do your {fuelType.description}&nbsp;vendors indicate they are including the total expenditure amount for a complete
                12-month period (not only cooling or heating seasons)?
                <br/>
                <label>
                    <input type="radio"
                        name="IncludingComplete12MonthFlag"
                        id="IncludingComplete12MonthFlag_true"
                        value="true"
                        checked={fuelType.IncludingComplete12MonthFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingComplete12MonthFlag"
                        id="IncludingComplete12MonthFlag_false"
                        value="false"
                        checked={fuelType.IncludingComplete12MonthFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludingComplete12MonthFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.IncludingComplete12MonthFlag === false
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Vendors should be reporting for a full 12 month period only. If your vendors are reporting
                        for less than 12 months, this will cause your average&nbsp;{fuelType.description}&nbsp;expenditures to be
                        incorrectly underreported.
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IncludingComplete12MonthDesc"
                            id="IncludingComplete12MonthDesc" style={{width:"100%"}}
                            value={fuelType.IncludingComplete12MonthDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*INDICATING LESS THAN 12 MONTH*/}
            <li>
                Do your {fuelType.description}&nbsp;vendors confirm they are indicating if an account’s expenditure data represents less
                than 12-months, such as due to the account closing, moving, or a client switched vendors (for delivered
                fuels)?
                <br/>
                <label>
                    <input type="radio"
                        name="IndicatingLessThan12MonthFlag"
                        id="IndicatingLessThan12MonthFlag_true"
                        value="true"
                        checked={fuelType.IndicatingLessThan12MonthFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IndicatingLessThan12MonthFlag"
                        id="IndicatingLessThan12MonthFlag_false"
                        value="false"
                        checked={fuelType.IndicatingLessThan12MonthFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.IndicatingLessThan12MonthFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.IndicatingLessThan12MonthFlag === false
                  &&<span><strong>Requires followup.</strong>&nbsp;
                        If a client`s expenditure data represents less than 12-months for any reason, this needs 
                        to be indicated and accounted when calculating your average expenditures. If your vendors 
                        are not indicating accounts that represent less than 12-months, this will cause you average 
                        expenditures to be underreported.
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IndicatingLessThan12MonthDesc"
                            id="IndicatingLessThan12MonthDesc" style={{width:"100%"}}
                            value={fuelType.IndicatingLessThan12MonthDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*AFTER DISCOUNTS*/}
            <li>
                Are your {fuelType.description}&nbsp;vendors reporting expenditure amounts after low-income discounts have been applied?
                <br/>
                <label>
                    <input type="radio"
                        name="ReportingAfterDiscountsFlag"
                        id="ReportingAfterDiscountsFlag_true"
                        value="true"
                        checked={fuelType.ReportingAfterDiscountsFlag === true}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="ReportingAfterDiscountsFlag"
                        id="ReportingAfterDiscountsFlag_false"
                        value="false"
                        checked={fuelType.ReportingAfterDiscountsFlag === false}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No / Don't Know</span>
                </label>
                <br/ >
                {fuelType.ReportingAfterDiscountsFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.ReportingAfterDiscountsFlag === false
                  &&<span>
                        <strong>Requires followup.</strong>&nbsp;
                        Your {fuelType.description}&nbsp;vendors should be sending billing data after low-income discounts have been applied.
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="ReportingAfterDisnbsp;countsDesc"
                            id="ReportingAfterDiscountsDesc" style={{width:"100%"}}
                            value={fuelType.ReportingAfterDiscountsDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>


            {(state.assessment1ShowCatchallQuestionUnder(fuelType) === true && showDontKnowNote === true)
            &&
                <div>
                    It appears that your potential data reliability issue cannot be
                    explained by the most common reasons we have found
                    for why states' estimates differ from the SEDS.
                    Please contact APPRISE to discuss other potential
                    explanations for this discrepancy. If you have any
                    ideas about what might be causing the discrepancy
                    please document it in the response box below.                        
                    <textarea  name="OtherReasonDesc"
                        id="OtherReasonDesc" style={{width:"100%"}}
                        value={fuelType.OtherReasonDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                </div>
            }


        </ol>
    </div>
);

export default Assessment1QuestionsUnderReporting;
